import { ClienteXCiudad } from "../../../login/cliente_login";

export class ClienteXAseguradoraEntity {
    constructor(        
       public  cliente?:ClienteXCiudad,
        public  AseCod ?: number
    ){

    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/fianzas/entities/clientexseguradora_entity.ts